import { Component } from "@angular/core";
import {
  NavController,
  Nav,
  NavParams,
  AlertController,
  ToastController,
  LoadingController,
  MenuController,
  ModalController,
  Events,
  Config,
  ActionSheetController,
} from "ionic-angular";

import {
  Project,
  Master,
  UserMyRadiant as User,
  HelperMyRadiant,
  NotificationProvider,
} from "@providers/index";
import { LoginPage, TabsPage, HomePage } from "../";
import { Login as LoginProvider } from "@providers/myradiant/login/login";
import { ForbidenloginComponent } from "../../../components/forbidenlogin/forbidenlogin";

import { AppPresensi } from "../../presensi";
import { AppActivity } from "../../activity";
import { DashboardPage } from "../../project_mobile";
import { HomePage as AppAdvance } from "../../advance_mobile";
import {
  AssetPage,
  HomePage as HomeAsset,
  LoginPage as LoginAsset,
} from "../../asset";

import { LoginPage as LoginMarketing } from "../../marketing";
import { NotifikasiPage } from "../notifikasi/page";

import { ListFormPage, ListFormResponsePage } from "../../survey";
import {
  ListFormPageDynamic,
  ListFormResponsePageDynamic,
} from "../../dynamic_form";
import { ProjectDetailPage as ProjectDetailPageMarketing } from "@pages/marketing";
import { ProjectDetailPage } from "@pages/project_mobile";
import { LsAssignmentPage } from "@pages/asset";

import { AppAttendance } from "../../attendance";

import { ListFormOpnamePage } from "../../opname";
import { LoginPageAproval } from "@pages/aproval_erp";

import { CupertinoPane, CupertinoSettings } from "cupertino-pane";

@Component({
  selector: "page-portal-dashboard",
  templateUrl: "page.html",
})
export class PortalPage {
  loading: any;
  form = {
    username: "",
    password: "",
  };
  data = {
    jml_notifikasi: this.notifikasiProvider.jmlNotifikasi,
  };
  state = {
    modul: {
      marketing: true,
      project  : true,
      presensi : true,
      activity : true,
      asset    : true,
      advance  : true,
      approval : true,
    },
    attendance: true,
    survey: true,
    form: true,
    opname: true,
  };
  submodul: any = [];
  list_shortcut: any = [];
  modul_with_akses: any[];
  isHaveApprovalAccess: any = false;

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private menuCtrl: MenuController,
    public nav: Nav,
    public loginProvider: LoginProvider,
    public masterApi: Master,
    public projectApi: Project,
    public userApi: User,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public helper: HelperMyRadiant,
    public events: Events,
    public notifikasiProvider: NotificationProvider,
    public config: Config,
    public actSheetCtrl: ActionSheetController
  ) {
    this.checkLogin();
    this.notifikasiProvider.refreshNotification();
    this.events.subscribe("notification:update", (notif) => {
      // console.log(notif);
      this.setNotif(notif.jml_notifikasi);
    });
  }

  setNotif(jml) {
    this.data.jml_notifikasi = jml;
    // console.log(this.data.jml_notifikasi);
  }

  doRefresh(refresher) {
    refresher.complete();
  }

  toModul(evt, modul) {
    let modul_name = modul.toLowerCase();
    localStorage.removeItem("tabActiveProfile");
    this.config.set("backButtonText", "");
    if (modul_name == "employee attendance") {
      modul_name = "attendance";
    }
    // console.log(modul_name);
    if (this.state[modul_name]) {
      switch (modul) {
        case "Presensi":
          this.nav.setRoot(AppPresensi);
          this.events.publish("modul:presensi");
          break;
        case "Activity":
          this.nav.setRoot(AppActivity);
          this.events.publish("modul:activity");
          break;
        case "Advance":
          this.nav.setRoot(AppAdvance);
          this.events.publish("modul:advance");
          break;
        case "Project":
          this.nav.setRoot(DashboardPage);
          this.events.publish("modul:project");
          break;
        case "Asset":
          this.nav.setRoot(LoginAsset);
          this.events.publish("modul:asset");
          break;
        case "Marketing":
          this.nav.setRoot(LoginMarketing);
          this.events.publish("modul:marketing");
          break;
        case "Approval":
          // this.nav.setRoot(LoginPageAproval);
          // this.events.publish("modul:aproval_erp");
          this.selectSubModulApproval();
          break;
        case "Survey":
          this.nav.setRoot(ListFormPage);
          this.events.publish("modul:survey");
          break;
        case "Attendance":
          this.nav.setRoot(AppAttendance);
          this.events.publish("modul:attendance");
          break;
        case "Employee Attendance":
          this.nav.setRoot(AppAttendance);
          this.events.publish("modul:attendance");
          break;
        case "Form":
          this.nav.setRoot(ListFormPageDynamic);
          this.events.publish("modul:form");
          break;
        case "Opname":
          this.nav.setRoot(ListFormOpnamePage);
          this.events.publish("modul:opname");
          break;
        default:
      }
    } else {
      this.helper.presentToast("You don't have access to this feature");
    }
  }

  public checkLogin() {
    let is_loginProvider = this.userApi.is_login;
    if (localStorage.form_login != undefined) {
      let me = this;
      this.userApi.hak_akses_modul.map(function (modul) {
        // if(modul.active_sts == 1){
        me.submodul.push(modul);
        // if ((modul.id = 1)) {
        //   if ((modul.hak_akses = 1)) {
        //     me.isHaveApprovalAccess = true;
        //   }
        // }
        // }
      });
      // // console.log("user hak akses modul => ", this.userApi.hak_akses_modul);
      // // console.log("list sub modul => ", this.submodul);
      this.getShortcut();
      if (is_loginProvider == 0) {
        this.getDataLogin();
      }
      // else{
      //   this.checkHakAksesModul(this.userApi.hak_akses_modul);
      // }
    } else {
      let forbidenModal = this.modalCtrl.create(ForbidenloginComponent);
      forbidenModal.onDidDismiss((menu) => {
        if (menu == "home") {
          this.nav.setRoot(TabsPage, { tabIndex: 0 });
        } else {
          this.nav.setRoot(LoginPage);
        }
      });
      forbidenModal.present();
      // let myItem = localStorage.getItem('stateLoadBerita');
      localStorage.clear();
      // localStorage.setItem('stateLoadBerita',myItem);
      this.menuCtrl.enable(false, "MainMenu");
    }
    // console.log("modul => ", this.submodul);
  }

  getLanguage() {}

  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: "Yakin akan keluar ?",
      buttons: [
        {
          text: "Tidak",
          handler: () => {},
        },
        {
          text: "Ya",
          handler: () => {
            // this.logout();
          },
        },
      ],
    });
    confirm.present();
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    this.loading.present();
  }

  presentToast(msg) {
    this.toastCtrl
      .create({
        message: msg,
        duration: 3000,
        position: "top",
      })
      .present();
  }

  getDataLogin() {
    this.showLoading();

    this.form = JSON.parse(localStorage.form_login);
    let params = this.form;

    this.userApi.login(params).subscribe(
      (resp: any) => {
        this.loading.dismiss();
        if (resp.success) {
          localStorage.is_login = 1;
          localStorage.form_login = JSON.stringify(this.form);
          localStorage.data_user = JSON.stringify(resp);
          this.loginProvider.setSession();
          this.menuCtrl.enable(true, "MainMenu");
          // this.checkHakAksesModul(resp.modul_akses);
        } else {
          this.events.publish("user:want_sign_out");
        }
      },
      (err) => {
        this.presentToast("Error");
        this.loading.dismiss();
      }
    );
  }

  checkHakAksesModul(modul) {
    let output = "enable";

    if (this.userApi.is_login) {
      if (modul.use_permission == 1) {
        this.userApi.hak_akses_modul.forEach((row) => {
          if (row.id == modul.id) {
            this.state[row.app_name.toLowerCase()] =
              row.hak_akses == 1 ? true : false;
            output = row.hak_akses == 1 ? "enable" : "disable";
            output += " " + row.app_name;
          }
        });
      }
    }
    return "card card-ios " + output;
  }

  selectSubModulApproval() {
    this.isHaveApprovalAccess = true;
    this.showLoading();

    let settings: CupertinoSettings = {
      showDraggable: false,
      backdrop: true,
      breaks: {
        top: {
          // Topper point that pane can reach
          enabled: true, // Enable or disable breakpoint
          height: 350, // Pane breakpoint height
          bounce: true, // Bounce pane on transition
        },
        middle: {
          // Topper point that pane can reach
          enabled: true, // Enable or disable breakpoint
          height: 300, // Pane breakpoint height
          bounce: true, // Bounce pane on transition
        },
      },
    };

    setTimeout(() => {
      this.loading.dismiss();
      let myPane = new CupertinoPane(".sub-modul-approval", settings);
      myPane.present({ animate: true });
    }, 500);
  }
  toSubModulApproval(app) {
    this.userApi.approval_modul_selected = app;
    localStorage.setItem("approval_modul", app);
    this.showLoading();
    setTimeout(() => {
      this.loading.dismiss();
      this.nav.setRoot(LoginPageAproval);
      this.events.publish("modul:aproval_erp");
    }, 500);
  }

  getShortcut() {
    let params = {};
    let temp_shortcut = [];
    this.userApi.getListShortcut(params).subscribe((resp: any) => {
      if (resp.success) {
        temp_shortcut = resp.data;
        // console.log("all shortcut => ", temp_shortcut);
        this.userApi.hak_akses_modul.forEach((row) => {
          temp_shortcut.forEach((sc) => {
            if (
              (row.hak_akses == 1 && sc.modul_id == row.id) ||
              (row.use_permission == 0 && sc.modul_id == row.id)
            ) {
              this.list_shortcut.push(sc);
            }
          });
        });
      }
    });
    // console.log("shortcut with akses => ", this.list_shortcut);
  }

  onClickShortcut(shortcut) {
    let arg = JSON.parse(shortcut.data);
    this.config.set("backButtonText", "");
    if (arg.act == "to_employee_activity_monitoring") {
      this.nav.push(ListFormResponsePage, {
        form_id: arg.form_id,
      });
    }
    if (arg.act == "to_detail_project") {
      this.nav.push(ProjectDetailPage, {
        project_id: arg.project_id,
      });
    }
    if (arg.act == "to_detail_tender") {
      this.nav.push(ProjectDetailPageMarketing, {
        tender_id: arg.tender_id,
      });
    }
    if (arg.act == "to_list_assignment") {
      this.nav.push(LsAssignmentPage);
    }
  }

  showNotification() {
    // this.events.publish('notification:update',{jml_notifikasi:0});
    this.nav.push(NotifikasiPage);
  }

  // logout(){
  //   localStorage.clear();
  //   this.navCtrl.push(LoginPage);
  // }

  // toProfile(){
  //   this.navCtrl.push(ProfilePage);
  // }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/portal/page.ts